import React from 'react';
import { CalendarDaysIcon, CheckIcon, CreditCardIcon, FileTextIcon } from 'lucide-react';
import { bill } from '../../data/eau';
interface WaterBillCardProps {
  paid: boolean;
  onPay: () => void;
}
export function WaterBillCard({
  paid,
  onPay
}: WaterBillCardProps) {
  return <section aria-labelledby="facture-titre" className="rounded-3xl border border-slate-200 bg-ville-navy p-6 text-white" data-id="element-1275" data-mp="1skawn13v9v1m">
      <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-ville-lime" data-id="element-1276" data-mp="14vhtokotumxi">
        <FileTextIcon className="h-4 w-4" aria-hidden="true" data-id="element-1277" data-mp="zwx219nn5bko" />
        Facture d’eau {bill.reference}
      </p>
      <h2 id="facture-titre" className="mt-3 text-3xl font-extrabold tracking-tight" data-id="element-1278" data-mp="1euh1k11rqejg">
        {bill.amount}
      </h2>
      <dl className="mt-3 space-y-1.5 text-sm text-white/75" data-id="element-1279" data-mp="19vw0y0iltsuh">
        <div className="flex items-center gap-2" data-id="element-1280" data-mp="2q6qalsx34akf">
          <dt className="sr-only" data-id="element-1281" data-mp="2l8yj300cqqgr">Période</dt>
          <dd data-id="element-1282" data-mp="2l86mpmyxkopf">
            {bill.period} · {bill.consumption}
          </dd>
        </div>
        <div className="flex items-center gap-2" data-id="element-1283" data-mp="1xwl8eqibjzmh">
          <CalendarDaysIcon className="h-4 w-4 shrink-0 text-white/50" aria-hidden="true" data-id="element-1284" data-mp="1y00mpr4654mu" />
          <dt className="sr-only" data-id="element-1285" data-mp="22yu0lkndaxnj">Échéance</dt>
          <dd data-id="element-1286" data-mp="27vkjefqk47cn">Échéance le {bill.dueOn}</dd>
        </div>
      </dl>

      {paid ? <p className="mt-5 inline-flex items-center gap-2 rounded-full bg-white/10 px-5 py-2.5 text-sm font-bold text-white" data-id="element-1287" data-mp="2bxxod1xhc18d">
          <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-1288" data-mp="1f8g8xv8p30th" />
          Payée — reçu dans votre profil
        </p> : <button type="button" onClick={onPay} className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-full bg-ville-lime px-6 py-3 text-sm font-bold text-ville-navy transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-ville-navy" data-id="element-1289" data-mp="1k6hqucudwu3d">
          <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-1290" data-mp="23t6b45ae4w17" />
          Payer ma facture
        </button>}
    </section>;
}